<ep-location-form [form]="locationForm.controls.Details" [mode]="(mode$ | async)!"></ep-location-form>
<app-location-map-picker
  [coordinates]="locationForm.controls.Coordinates"
  [address]="locationForm.controls.Details.controls.Address"
  [mode]="(mode$ | async)!"
></app-location-map-picker>
